import React from 'react'
import Login from './Components/Javascript/Forms/Login'

export default function LoginPage() {
  return (
    <div>
      <Login/>
    </div>
  )
}
